export enum DatasheetGridSettingsMarginType {
  fhq = 'fhq',
  tablet = 'tablet',
  custom = 'custom',
}

export type DatasheetGridSettingsDto = {
  horizontalGrid: number;
  verticalGrid: number;
  showGrid: boolean;
  showPageBreaks: boolean;
  snapToGrid: boolean;
  showEditTabOrder: boolean;
  showMargins: boolean;
  marginType?: DatasheetGridSettingsMarginType;
  marginWidth: number;
  marginHeight: number;
};